// import React from "react";
// import { useOutletContext, useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { 
//   FiCreditCard, FiDollarSign, FiRefreshCw, 
//   FiArrowUp, FiArrowDown, FiInfo, FiClipboard,
//   FiClock, FiPlus, FiMinus, FiFilter, FiX,
//   FiTrendingUp, FiUsers, FiDownload, FiShield,
//   FiBriefcase, FiCheckCircle, FiVideo, FiGift
// } from "react-icons/fi";
// import { API_BASE_URL } from "../utils/config";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import { toast } from "react-toastify";
// import "./EmployeeDashboard.css";

// const CandidateWallet = () => {
//   const { profile } = useOutletContext();
//   const navigate = useNavigate();

//   const [walletData, setWalletData] = React.useState(null);
//   const [loading, setLoading] = React.useState(true);
//   const [error, setError] = React.useState(null);
//   const [showHistory, setShowHistory] = React.useState(false);
//   const [filterType, setFilterType] = React.useState("all");
//   const [showFilterDropdown, setShowFilterDropdown] = React.useState(false);
//   const [showExportMenu, setShowExportMenu] = React.useState(false);

//   React.useEffect(() => {
//     if (profile?._id) {
//       fetchWalletData();
//     }
//   }, [profile?._id]);

//   const fetchWalletData = async () => {
//     try {
//       setLoading(true);
//       const candidateId = profile?._id || profile?.candidateId;
//       if (!candidateId) {
//         throw new Error("Candidate ID not found");
//       }
      
//       const response = await axios.get(`${API_BASE_URL}/candidate/mywallet/${candidateId}`);
      
//       if (response.data?.success) {
//         setWalletData(response.data.data);
//         setError(null);
//       } else {
//         setError("Failed to fetch wallet data");
//       }
//     } catch (err) {
//       console.error("Error fetching wallet:", err);
//       setError(err.response?.data?.message || "Unable to load wallet. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getFilteredHistory = () => {
//     if (!walletData?.walletHistory) return [];
    
//     if (filterType === "credit") {
//       return walletData.walletHistory.filter(h => h.type === "credit");
//     } else if (filterType === "debit") {
//       return walletData.walletHistory.filter(h => h.type === "debit");
//     }
//     return walletData.walletHistory;
//   };

//   const getTypeIcon = (type) => {
//     return type === "credit" ? 
//       <FiPlus className="text-green-500" size={12} /> : 
//       <FiMinus className="text-red-500" size={12} />;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
//   };

//   const getHistorySummary = () => {
//     if (!walletData?.walletHistory) return { credits: 0, debits: 0 };
    
//     const credits = walletData.walletHistory
//       .filter(h => h.type === "credit")
//       .reduce((sum, h) => sum + h.coins, 0);
    
//     const debits = walletData.walletHistory
//       .filter(h => h.type === "debit")
//       .reduce((sum, h) => sum + h.coins, 0);
    
//     return { credits, debits };
//   };

//   const summary = getHistorySummary();
//   const filteredHistory = getFilteredHistory();
//   const displayedHistory = showHistory ? filteredHistory : filteredHistory.slice(0, 5);

//   const handleExport = (format) => {
//     if (!filteredHistory.length) {
//       toast.warning("No transactions to export");
//       return;
//     }

//     const exportData = filteredHistory.map(t => ({
//       "Date": new Date(t.createdAt).toLocaleString(),
//       "Type": t.type.toUpperCase(),
//       "Coins": t.type === "credit" ? `+${t.coins}` : `-${t.coins}`,
//       "Message": t.message,
//       "Transaction ID": t._id
//     }));

//     if (format === "excel") {
//       const ws = XLSX.utils.json_to_sheet(exportData);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, "Wallet History");
//       XLSX.writeFile(wb, `wallet_history_${new Date().toISOString().split('T')[0]}.xlsx`);
//       toast.success("Exported to Excel successfully!");
//     } else if (format === "csv") {
//       const ws = XLSX.utils.json_to_sheet(exportData);
//       const csv = XLSX.utils.sheet_to_csv(ws);
//       const blob = new Blob([csv], { type: "text/csv" });
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `wallet_history_${new Date().toISOString().split('T')[0]}.csv`;
//       a.click();
//       URL.revokeObjectURL(url);
//       toast.success("Exported to CSV successfully!");
//     }
//     setShowExportMenu(false);
//   };

//   if (loading) {
//     return (
//       <div className="w-full h-full flex items-center justify-center min-h-[400px]">
//         <div className="text-center">
//           <div className="w-16 h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div>
//           <p className="text-sm text-gray-500 font-medium">Loading wallet data...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="w-full h-full flex items-center justify-center min-h-[400px]">
//         <div className="text-center max-w-md px-6">
//           <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-5">
//             <FiCreditCard className="text-red-400 text-3xl" />
//           </div>
//           <h3 className="text-lg font-bold text-gray-800 mb-2">Unable to Load Wallet</h3>
//           <p className="text-sm text-gray-500 mb-6">{error}</p>
//           <button
//             onClick={fetchWalletData}
//             className="px-6 py-2.5 bg-gradient-to-r from-green-500 to-blue-600 text-white rounded-xl text-xs font-bold hover:opacity-90 transition shadow-md"
//           >
//             Try Again
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="emp-dash">
//       <div className="p-4 sm:p-6 lg:p-8">
//         {/* Dashboard Header */}
//         <div className="emp-dash__header">
//           <div>
//             <h1 className="emp-dash__greeting">
//               My <span>Wallet</span>
//             </h1>
//             <p className="emp-dash__subtitle">
//               Track your earnings and transactions
//             </p>
//           </div>
//           <div className="emp-dash__date-pill">
//             <FiClipboard />
//             <span>
//               {new Date().toLocaleDateString("en-US", {
//                 weekday: "short",
//                 year: "numeric",
//                 month: "short",
//                 day: "numeric",
//               })}
//             </span>
//           </div>
//         </div>

//         {/* Wallet Balance Card */}
//         {/* <div className="emp-dash__card mb-6">
//           <div className="p-6 md:p-8 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 rounded-3xl relative overflow-hidden">
//             <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none"></div>
//             <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full blur-2xl -ml-24 -mb-24 pointer-events-none"></div>
//             <div className="relative flex items-center justify-between">
//               <div className="flex items-center gap-4 md:gap-5">
//                 <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-white/20 backdrop-blur-md flex items-center justify-center shadow-xl border border-white/30">
//                   <FiCreditCard className="text-white text-2xl md:text-3xl" />
//                 </div>
//                 <div>
//                   <p className="text-[10px] md:text-xs font-bold text-blue-100 uppercase tracking-[0.2em] mb-1">Total Balance</p>
//                   <div className="flex items-baseline gap-2">
//                     <FiDollarSign className="text-yellow-300 text-xl md:text-2xl" />
//                     <span className="text-3xl md:text-4xl font-black text-white">
//                       {walletData?.totalCoins || 0}
//                     </span>
//                     <span className="text-sm md:text-base text-blue-200 font-bold">coins</span>
//                   </div>
//                 </div>
//               </div>
//               <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-3">
//                 <FiDollarSign className="text-white text-3xl" />
//               </div>
//             </div>
//           </div>
//         </div> */}

//         {/* Stats Row */}
//         <div className="emp-dash__stats grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
//           <div className="emp-dash__stat">
//             <div className="emp-dash__stat-top">
//               <span className="emp-dash__stat-label">Total Coins</span>
//               <div className="emp-dash__stat-icon emp-dash__stat-icon--indigo">
//                 <FiDollarSign />
//               </div>
//             </div>
//             <div className="emp-dash__stat-value">
//               {walletData?.totalCoins || 0}
//             </div>
//             <div className="emp-dash__stat-meta">available balance</div>
//           </div>
          
//           <div className="emp-dash__stat">
//             <div className="emp-dash__stat-top">
//               <span className="emp-dash__stat-label">Earned</span>
//               <div className="emp-dash__stat-icon emp-dash__stat-icon--emerald">
//                 <FiArrowUp />
//               </div>
//             </div>
//             <div className="emp-dash__stat-value text-emerald-600">
//               +{summary.credits}
//             </div>
//             <div className="emp-dash__stat-meta">total credited</div>
//           </div>
          
//           <div className="emp-dash__stat">
//             <div className="emp-dash__stat-top">
//               <span className="emp-dash__stat-label">Spent</span>
//               <div className="emp-dash__stat-icon emp-dash__stat-icon--rose">
//                 <FiArrowDown />
//               </div>
//             </div>
//             <div className="emp-dash__stat-value text-red-600">
//               -{summary.debits}
//             </div>
//             <div className="emp-dash__stat-meta">total debited</div>
//           </div>
          
//           <div className="emp-dash__stat">
//             <div className="emp-dash__stat-top">
//               <span className="emp-dash__stat-label">Transactions</span>
//               <div className="emp-dash__stat-icon emp-dash__stat-icon--violet">
//                 <FiRefreshCw />
//               </div>
//             </div>
//             <div className="emp-dash__stat-value">
//               {filteredHistory.length}
//             </div>
//             <div className="emp-dash__stat-meta">total transactions</div>
//           </div>
//         </div>

//         {/* Transaction Section */}
//         <div className="emp-dash__card mb-6">
//           <div className="emp-dash__card-header">
//             <div className="flex items-center gap-4">
//               <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-100 text-blue-600 flex items-center justify-center shadow-inner border border-blue-200/50">
//                 <FiRefreshCw size={24} />
//               </div>
//               <div>
//                 <h3 className="emp-dash__card-title">Transaction History</h3>
//                 <p className="emp-dash__card-desc">{filteredHistory.length} transactions</p>
//               </div>
//             </div>
//             <div className="flex gap-1.5">
//               <button
//                 onClick={() => setFilterType("all")}
//                 className={`px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all ${
//                   filterType === "all"
//                     ? 'bg-blue-600 text-white shadow-md'
//                     : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                 }`}
//               >
//                 All
//               </button>
//               <button
//                 onClick={() => setFilterType("credit")}
//                 className={`px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all flex items-center gap-1 ${
//                   filterType === "credit"
//                     ? 'bg-emerald-600 text-white shadow-md'
//                     : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                 }`}
//               >
//                 <FiArrowUp className="text-[8px]" /> Credits
//               </button>
//               <button
//                 onClick={() => setFilterType("debit")}
//                 className={`px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all flex items-center gap-1 ${
//                   filterType === "debit"
//                     ? 'bg-red-600 text-white shadow-md'
//                     : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                 }`}
//               >
//                 <FiArrowDown className="text-[8px]" /> Debits
//               </button>
//             </div>
//           </div>

//           <div className="emp-dash__card-body bg-gray-50/50">
//             {filteredHistory.length > 0 ? (
//               <div className="space-y-2 max-h-[400px] overflow-y-auto custom-scrollbar">
//                 {displayedHistory.map((transaction, index) => (
//                   <div
//                     key={transaction._id || index}
//                     className={`flex items-center justify-between p-3 rounded-xl transition-all ${
//                       transaction.type === "credit" 
//                         ? "bg-emerald-50/50 border border-emerald-100 hover:bg-emerald-50" 
//                         : "bg-red-50/50 border border-red-100 hover:bg-red-50"
//                     }`}
//                   >
//                     <div className="flex items-center gap-3">
//                       <div className={`w-10 h-10 rounded-xl flex items-center justify-center shadow-sm ${
//                         transaction.type === "credit" 
//                           ? "bg-emerald-500" 
//                           : "bg-red-500"
//                       }`}>
//                         {transaction.type === "credit" ? (
//                           <FiPlus className="text-white text-sm" />
//                         ) : (
//                           <FiMinus className="text-white text-sm" />
//                         )}
//                       </div>
//                       <div>
//                         <p className="text-xs font-bold text-gray-800">{transaction.message}</p>
//                         <div className="flex items-center gap-1.5 mt-0.5">
//                           <FiClock className="text-[8px] text-gray-400" />
//                           <p className="text-[9px] text-gray-500">{formatDate(transaction.createdAt)}</p>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="text-right">
//                       <p className={`text-sm font-bold ${
//                         transaction.type === "credit" ? "text-emerald-600" : "text-red-600"
//                       }`}>
//                         {transaction.type === "credit" ? "+" : "-"} {transaction.coins}
//                       </p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center py-10">
//                 <div className="w-16 h-16 rounded-2xl bg-gray-50 flex items-center justify-center mx-auto mb-3">
//                   <FiRefreshCw className="text-2xl text-gray-300" />
//                 </div>
//                 <p className="text-xs font-bold text-gray-500">No transactions found</p>
//               </div>
//             )}

//             {filteredHistory.length > 5 && (
//               <div className="mt-4 text-center">
//                 <button
//                   onClick={() => setShowHistory(!showHistory)}
//                   className="text-[10px] font-bold text-blue-600 hover:text-blue-800 transition-colors"
//                 >
//                   {showHistory ? "Show Less" : "View All"}
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Info Card */}
//         <div className="emp-dash__card mb-6">
//           <div className="emp-dash__card-header">
//             <div className="flex items-center gap-4">
//               <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-emerald-50 to-emerald-100 text-emerald-600 flex items-center justify-center shadow-inner border border-emerald-200/50">
//                 <FiGift size={24} />
//               </div>
//               <div>
//                 <h3 className="emp-dash__card-title">How to Earn Coins</h3>
//                 <p className="emp-dash__card-desc">Ways to increase your balance</p>
//               </div>
//             </div>
//           </div>
//           <div className="emp-dash__card-body bg-gray-50/50">
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//               {[
//                 { action: "Apply for a Job", reward: "20 Coins", icon: FiBriefcase, color: "blue", gradient: "from-blue-50 to-indigo-100", iconBg: "bg-blue-100", iconColor: "text-blue-600" },
//                 { action: "Complete Assessment", reward: "10 Coins", icon: FiCheckCircle, color: "emerald", gradient: "from-emerald-50 to-green-100", iconBg: "bg-emerald-100", iconColor: "text-emerald-600" },
//                 { action: "Attend Interview", reward: "50 Coins", icon: FiVideo, color: "violet", gradient: "from-violet-50 to-purple-100", iconBg: "bg-violet-100", iconColor: "text-violet-600" },
//               ].map((item, i) => (
//                 <div 
//                   key={i}
//                   className="group relative overflow-hidden bg-white rounded-xl p-4 border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all cursor-pointer"
//                 >
//                   <div className={`absolute inset-0 bg-gradient-to-r ${item.gradient} opacity-0 group-hover:opacity-100 transition-opacity`}></div>
//                   <div className="relative flex items-center gap-3">
//                     <div className={`w-10 h-10 rounded-xl ${item.iconBg} ${item.iconColor} flex items-center justify-center shadow-sm`}>
//                       <item.icon size={18} />
//                     </div>
//                     <div className="flex-1">
//                       <p className="text-xs font-bold text-gray-800">{item.action}</p>
//                       <p className={`text-[10px] font-bold ${item.iconColor} mt-0.5`}>{item.reward}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Rewards Card */}
//         <div className="emp-dash__card mb-6">
//           <div className="emp-dash__card-header">
//             <div className="flex items-center gap-4">
//               <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-50 to-orange-100 text-amber-600 flex items-center justify-center shadow-inner border border-amber-200/50">
//                 <FiTrendingUp size={24} />
//               </div>
//               <div>
//                 <h3 className="emp-dash__card-title">Rewards & Benefits</h3>
//                 <p className="emp-dash__card-desc">Bonus opportunities</p>
//               </div>
//             </div>
//           </div>
//           <div className="emp-dash__card-body bg-gray-50/50">
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div className="group relative overflow-hidden bg-white rounded-xl p-4 border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all cursor-pointer">
//                 <div className="absolute inset-0 bg-gradient-to-r from-emerald-50 to-green-100 opacity-0 group-hover:opacity-100 transition-opacity"></div>
//                 <div className="relative flex items-start gap-3">
//                   <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center text-emerald-600 shadow-sm">
//                     <FiTrendingUp size={18} />
//                   </div>
//                   <div className="flex-1">
//                     <p className="text-xs font-bold text-gray-800">Top Performer Bonus</p>
//                     <p className="text-[10px] text-gray-500 mt-0.5">Earn extra 100 coins for being in top 10%</p>
//                   </div>
//                 </div>
//               </div>
//               <div className="group relative overflow-hidden bg-white rounded-xl p-4 border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all cursor-pointer">
//                 <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-indigo-100 opacity-0 group-hover:opacity-100 transition-opacity"></div>
//                 <div className="relative flex items-start gap-3">
//                   <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center text-blue-600 shadow-sm">
//                     <FiUsers size={18} />
//                   </div>
//                   <div className="flex-1">
//                     <p className="text-xs font-bold text-gray-800">Referral Program</p>
//                     <p className="text-[10px] text-gray-500 mt-0.5">Refer a friend and earn 200 coins</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="flex items-center justify-center gap-2 text-[9px] font-bold text-gray-400 uppercase tracking-widest py-4">
//           <FiClipboard className="text-indigo-400" />
//           Last Updated: {new Date().toLocaleDateString("en-US", {
//             weekday: "short",
//             year: "numeric",
//             month: "short",
//             day: "numeric",
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CandidateWallet;




import React from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { 
  FiCreditCard, FiDollarSign, FiRefreshCw, 
  FiArrowUp, FiArrowDown, FiInfo, FiClipboard,
  FiClock, FiPlus, FiMinus, FiFilter, FiX,
  FiTrendingUp, FiUsers, FiDownload, FiShield,
  FiBriefcase, FiCheckCircle, FiVideo, FiGift
} from "react-icons/fi";
import { API_BASE_URL } from "../utils/config";
import axios from "axios";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import "./EmployeeDashboard.css";

const CandidateWallet = () => {
  const { profile } = useOutletContext();
  const navigate = useNavigate();

  const [walletData, setWalletData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [showHistory, setShowHistory] = React.useState(false);
  const [filterType, setFilterType] = React.useState("all");
  const [showFilterDropdown, setShowFilterDropdown] = React.useState(false);
  const [showExportMenu, setShowExportMenu] = React.useState(false);

  React.useEffect(() => {
    if (profile?._id) {
      fetchWalletData();
    }
  }, [profile?._id]);

  const fetchWalletData = async () => {
    try {
      setLoading(true);
      const candidateId = profile?._id || profile?.candidateId;
      if (!candidateId) {
        throw new Error("Candidate ID not found");
      }

      const response = await axios.get(`${API_BASE_URL}/candidate/mywallet/${candidateId}`);

      if (response.data?.success) {
        setWalletData(response.data.data);
        setError(null);
      } else {
        setError("Failed to fetch wallet data");
      }
    } catch (err) {
      console.error("Error fetching wallet:", err);
      setError(err.response?.data?.message || "Unable to load wallet. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const getFilteredHistory = () => {
    if (!walletData?.walletHistory) return [];

    if (filterType === "credit") {
      return walletData.walletHistory.filter(h => h.type === "credit");
    } else if (filterType === "debit") {
      return walletData.walletHistory.filter(h => h.type === "debit");
    }
    return walletData.walletHistory;
  };

  const getTypeIcon = (type) => {
    return type === "credit" ? 
      <FiPlus className="text-green-500" size={12} /> : 
      <FiMinus className="text-red-500" size={12} />;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  };

  const getHistorySummary = () => {
    if (!walletData?.walletHistory) return { credits: 0, debits: 0 };

    const credits = walletData.walletHistory
      .filter(h => h.type === "credit")
      .reduce((sum, h) => sum + h.coins, 0);

    const debits = walletData.walletHistory
      .filter(h => h.type === "debit")
      .reduce((sum, h) => sum + h.coins, 0);

    return { credits, debits };
  };

  const summary = getHistorySummary();
  const filteredHistory = getFilteredHistory();
  const displayedHistory = showHistory ? filteredHistory : filteredHistory.slice(0, 5);

  const handleExport = (format) => {
    if (!filteredHistory.length) {
      toast.warning("No transactions to export");
      return;
    }

    const exportData = filteredHistory.map(t => ({
      "Date": new Date(t.createdAt).toLocaleString(),
      "Type": t.type.toUpperCase(),
      "Coins": t.type === "credit" ? `+${t.coins}` : `-${t.coins}`,
      "Message": t.message,
      "Transaction ID": t._id
    }));

    if (format === "excel") {
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Wallet History");
      XLSX.writeFile(wb, `wallet_history_${new Date().toISOString().split('T')[0]}.xlsx`);
      toast.success("Exported to Excel successfully!");
    } else if (format === "csv") {
      const ws = XLSX.utils.json_to_sheet(exportData);
      const csv = XLSX.utils.sheet_to_csv(ws);
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `wallet_history_${new Date().toISOString().split('T')[0]}.csv`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Exported to CSV successfully!");
    }
    setShowExportMenu(false);
  };

  if (loading) {
    return (
      <div className="w-full h-full flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-sm text-gray-500 font-medium">Loading wallet data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full h-full flex items-center justify-center min-h-[400px]">
        <div className="text-center max-w-md px-6">
          <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-5">
            <FiCreditCard className="text-red-400 text-3xl" />
          </div>
          <h3 className="text-lg font-bold text-gray-800 mb-2">Unable to Load Wallet</h3>
          <p className="text-sm text-gray-500 mb-6">{error}</p>
          <button
            onClick={fetchWalletData}
            className="px-6 py-2.5 bg-gradient-to-r from-green-500 to-blue-600 text-white rounded-xl text-xs font-bold hover:opacity-90 transition shadow-md"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="emp-dash">
      <div className="p-4 sm:p-6 lg:p-8">
        {/* Dashboard Header */}
        <div className="emp-dash__header">
          <div>
            <h1 className="emp-dash__greeting">
              My <span>Wallet</span>
            </h1>
            <p className="emp-dash__subtitle">
              Track your earnings and transactions
            </p>
          </div>
          <div className="emp-dash__date-pill">
            <FiClipboard />
            <span>
              {new Date().toLocaleDateString("en-US", {
                weekday: "short",
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </span>
          </div>
        </div>

        {/* Stats Row */}
        <div className="emp-dash__stats grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="emp-dash__stat">
            <div className="emp-dash__stat-top">
              <span className="emp-dash__stat-label">Total Coins</span>
              <div className="emp-dash__stat-icon emp-dash__stat-icon--indigo">
                <FiDollarSign />
              </div>
            </div>
            <div className="emp-dash__stat-value">
              {walletData?.totalCoins || 0}
            </div>
            <div className="emp-dash__stat-meta">available balance</div>
          </div>

          <div className="emp-dash__stat">
            <div className="emp-dash__stat-top">
              <span className="emp-dash__stat-label">Earned</span>
              <div className="emp-dash__stat-icon emp-dash__stat-icon--emerald">
                <FiArrowUp />
              </div>
            </div>
            <div className="emp-dash__stat-value text-emerald-600">
              +{summary.credits}
            </div>
            <div className="emp-dash__stat-meta">total credited</div>
          </div>

          <div className="emp-dash__stat">
            <div className="emp-dash__stat-top">
              <span className="emp-dash__stat-label">Debits</span>
              <div className="emp-dash__stat-icon emp-dash__stat-icon--rose">
                <FiArrowDown />
              </div>
            </div>
            <div className="emp-dash__stat-value text-red-600">
              {/* Only show minus sign if debited amount is greater than 0 */}
              {summary.debits > 0 ? `-${summary.debits}` : summary.debits}
            </div>
            <div className="emp-dash__stat-meta">total debited</div>
          </div>

          <div className="emp-dash__stat">
            <div className="emp-dash__stat-top">
              <span className="emp-dash__stat-label">Transactions</span>
              <div className="emp-dash__stat-icon emp-dash__stat-icon--violet">
                <FiRefreshCw />
              </div>
            </div>
            <div className="emp-dash__stat-value">
              {filteredHistory.length}
            </div>
            <div className="emp-dash__stat-meta">total transactions</div>
          </div>
        </div>

        {/* Transaction Section */}
        <div className="emp-dash__card mb-6">
          <div className="emp-dash__card-header">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-100 text-blue-600 flex items-center justify-center shadow-inner border border-blue-200/50">
                <FiRefreshCw size={24} />
              </div>
              <div>
                <h3 className="emp-dash__card-title">Transaction History</h3>
                <p className="emp-dash__card-desc">{filteredHistory.length} transactions</p>
              </div>
            </div>
            <div className="flex gap-1.5">
              <button
                onClick={() => setFilterType("all")}
                className={`px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all ${
                  filterType === "all"
                    ? 'bg-blue-600 text-white shadow-md'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                All
              </button>
              <button
                onClick={() => setFilterType("credit")}
                className={`px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all flex items-center gap-1 ${
                  filterType === "credit"
                    ? 'bg-emerald-600 text-white shadow-md'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <FiArrowUp className="text-[8px]" /> Credits
              </button>
              <button
                onClick={() => setFilterType("debit")}
                className={`px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all flex items-center gap-1 ${
                  filterType === "debit"
                    ? 'bg-red-600 text-white shadow-md'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <FiArrowDown className="text-[8px]" /> Debits
              </button>
            </div>
          </div>

          <div className="emp-dash__card-body bg-gray-50/50">
            {filteredHistory.length > 0 ? (
              <div className="space-y-2 max-h-[400px] overflow-y-auto custom-scrollbar">
                {displayedHistory.map((transaction, index) => (
                  <div
                    key={transaction._id || index}
                    className={`flex items-center justify-between p-3 rounded-xl transition-all ${
                      transaction.type === "credit" 
                        ? "bg-emerald-50/50 border border-emerald-100 hover:bg-emerald-50" 
                        : "bg-red-50/50 border border-red-100 hover:bg-red-50"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div className={`w-10 h-10 rounded-xl flex items-center justify-center shadow-sm ${
                        transaction.type === "credit" 
                          ? "bg-emerald-500" 
                          : "bg-red-500"
                      }`}>
                        {transaction.type === "credit" ? (
                          <FiPlus className="text-white text-sm" />
                        ) : (
                          <FiMinus className="text-white text-sm" />
                        )}
                      </div>
                      <div>
                        <p className="text-xs font-bold text-gray-800">{transaction.message}</p>
                        <div className="flex items-center gap-1.5 mt-0.5">
                          <FiClock className="text-[8px] text-gray-400" />
                          <p className="text-[9px] text-gray-500">{formatDate(transaction.createdAt)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className={`text-sm font-bold ${
                        transaction.type === "credit" ? "text-emerald-600" : "text-red-600"
                      }`}>
                        {transaction.type === "credit" ? "+" : "-"} {transaction.coins}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-10">
                <div className="w-16 h-16 rounded-2xl bg-gray-50 flex items-center justify-center mx-auto mb-3">
                  <FiRefreshCw className="text-2xl text-gray-300" />
                </div>
                <p className="text-xs font-bold text-gray-500">No transactions found</p>
              </div>
            )}

            {filteredHistory.length > 5 && (
              <div className="mt-4 text-center">
                <button
                  onClick={() => setShowHistory(!showHistory)}
                  className="text-[10px] font-bold text-blue-600 hover:text-blue-800 transition-colors"
                >
                  {showHistory ? "Show Less" : "View All"}
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Info Card */}
        <div className="emp-dash__card mb-6">
          <div className="emp-dash__card-header">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-emerald-50 to-emerald-100 text-emerald-600 flex items-center justify-center shadow-inner border border-emerald-200/50">
                <FiGift size={24} />
              </div>
              <div>
                <h3 className="emp-dash__card-title">How to Earn Coins</h3>
                <p className="emp-dash__card-desc">Ways to increase your balance</p>
              </div>
            </div>
          </div>
          <div className="emp-dash__card-body bg-gray-50/50">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[
                { action: "Apply for a Job", reward: "20 Coins", icon: FiBriefcase, color: "blue", gradient: "from-blue-50 to-indigo-100", iconBg: "bg-blue-100", iconColor: "text-blue-600" },
                { action: "Complete Assessment", reward: "10 Coins", icon: FiCheckCircle, color: "emerald", gradient: "from-emerald-50 to-green-100", iconBg: "bg-emerald-100", iconColor: "text-emerald-600" },
                { action: "Attend Interview", reward: "50 Coins", icon: FiVideo, color: "violet", gradient: "from-violet-50 to-purple-100", iconBg: "bg-violet-100", iconColor: "text-violet-600" },
              ].map((item, i) => (
                <div 
                  key={i}
                  className="group relative overflow-hidden bg-white rounded-xl p-4 border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all cursor-pointer"
                >
                  <div className={`absolute inset-0 bg-gradient-to-r ${item.gradient} opacity-0 group-hover:opacity-100 transition-opacity`}></div>
                  <div className="relative flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-xl ${item.iconBg} ${item.iconColor} flex items-center justify-center shadow-sm`}>
                      <item.icon size={18} />
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-bold text-gray-800">{item.action}</p>
                      <p className={`text-[10px] font-bold ${item.iconColor} mt-0.5`}>{item.reward}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Rewards Card */}
        <div className="emp-dash__card mb-6">
          <div className="emp-dash__card-header">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-50 to-orange-100 text-amber-600 flex items-center justify-center shadow-inner border border-amber-200/50">
                <FiTrendingUp size={24} />
              </div>
              <div>
                <h3 className="emp-dash__card-title">Rewards & Benefits</h3>
                <p className="emp-dash__card-desc">Bonus opportunities</p>
              </div>
            </div>
          </div>
          <div className="emp-dash__card-body bg-gray-50/50">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="group relative overflow-hidden bg-white rounded-xl p-4 border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all cursor-pointer">
                <div className="absolute inset-0 bg-gradient-to-r from-emerald-50 to-green-100 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <div className="relative flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center text-emerald-600 shadow-sm">
                    <FiTrendingUp size={18} />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs font-bold text-gray-800">Top Performer Bonus</p>
                    <p className="text-[10px] text-gray-500 mt-0.5">Earn extra 100 coins for being in top 10%</p>
                  </div>
                </div>
              </div>
              <div className="group relative overflow-hidden bg-white rounded-xl p-4 border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all cursor-pointer">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-indigo-100 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <div className="relative flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center text-blue-600 shadow-sm">
                    <FiUsers size={18} />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs font-bold text-gray-800">Referral Program</p>
                    <p className="text-[10px] text-gray-500 mt-0.5">Refer a friend and earn 200 coins</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-center gap-2 text-[9px] font-bold text-gray-400 uppercase tracking-widest py-4">
          <FiClipboard className="text-indigo-400" />
          Last Updated: {new Date().toLocaleDateString("en-US", {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </div>
      </div>
    </div>
  );
};



export default CandidateWallet;